import React, { useRef, useState, useEffect, useReducer } from 'react'
import { baseDomain, baseUrl } from 'utils/parseDomain'
import { faqListArr, faqCostList } from 'utils/faqList'
import DeviceId from 'utils/detectDevice'
import JsonLd from 'components/FaqScript'
import 'styles/faqSection.scss'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'

function FaqSection() {
  const GetMembershipTypes = () => {
    return faqCostList.map((arr, i) => (
      <div
        className="col-sm MembershipCardMargin"
        data-testid={arr.membershipType.replace(/ /g, '')}
      >
        <div className="costWrapperDesk">
          {arr.topSellar ? (
            <div className="row topSellar">Top Seller</div>
          ) : (
            <div className="topWrapper" />
          )}
          <div className="row costTitle costType">{arr.membershipType}</div>
          <div className="row costTitle">{arr.months}</div>
          {arr.features.length > 0 &&
            arr.features.map((val, k) => (
              <div
                className={`row ${
                  k === 3 ? 'paddingpxTextCssDesk4th' : 'paddingpxTextCssDesk'
                }`}
              >
                <div className="col-2 greenTick" />
                <div className="col">
                  {val}
                  {arr.features.length - 1 > k && (
                    <div className="featureDivider" />
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    ))
  }
  const GetMembershipTypesMobile = () => {
    return (
      <Carousel
        centerSlidePercentage={87.5}
        showThumbs={false}
        showArrows={false}
        showStatus={false}
      >
        <div data-testid="Gold" className="carouselCard">
          <div className="costWrapper">
            <div className="topWrapper" />
            <div className="row costTitle costType">Gold</div>
            <div className="row costTitle">3 Months</div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Connect directly with Matches
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                View detailed Profile information
              </div>
            </div>
          </div>
        </div>
        <div className="carouselCard" data-testid="GoldPlus">
          <div className="costWrapper">
            <div className="topWrapper" />
            <div className="row costTitle costType">Gold Plus</div>
            <div className="row costTitle">3 Months</div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Connect directly with Matches
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                View detailed Profile information
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Be featured under Spotlight
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">Standout with Bold Listing</div>
            </div>
          </div>
        </div>
        <div className="carouselCard" data-testid="Diamond">
          <div className="costWrapper">
            <div className="topWrapper" />
            <div className="row costTitle costType">Diamond</div>
            <div className="row costTitle">6 Months</div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Connect directly with Matches
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                View detailed Profile information
              </div>
            </div>
          </div>
        </div>
        <div className="carouselCard" data-testid="DiamodPlus">
          <div className="costWrapper">
            <div className="row topSellar">Top Seller</div>
            <div className="row costTitle costType">Diamod Plus</div>
            <div className="row costTitle">6 Months</div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Connect directly with Matches
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                View detailed Profile information
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Be featured under Spotlight
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">Standout with Bold Listing</div>
            </div>
          </div>
        </div>
        <div className="carouselCard" data-testid="PlatinumPlus">
          <div className="costWrapper">
            <div className="topWrapper" />
            <div className="row costTitle costType">Platinum Plus</div>
            <div className="row costTitle">12 Months</div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Connect directly with Matches
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                View detailed Profile information
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">
                Be featured under Spotlight
                <div className="featureDivider" />
              </div>
            </div>
            <div className="row paddingpxTextCss">
              <div className="col-2 greenTick" />
              <div className="col colTextAlign">Standout with Bold Listing</div>
            </div>
          </div>
        </div>
      </Carousel>
    )
  }

  const GetAnswers = ({ ans }) => {
    if (ans.length === 1) {
      return <>{ans[0]}</>
    } else if (ans.length > 1) {
      return (
        <>
          {ans[0]}
          {ans
            .filter((val, k) => k !== 0)
            .map(v => (
              <>
                <div className="spacer15" />
                {v}
              </>
            ))}
        </>
      )
    } else {
      return <></>
    }
  }

  const GetListAnswers = ({ ansUlLi }) => {
    if (ansUlLi.length > 0) {
      return (
        <>
          <div className="spacer15" />
          <ul>
            {ansUlLi.map((val, i) => (
              <li>
                <GetAnchorTagAnswer {...val} />
                <ul>
                  {val.li.length > 0 &&
                    val.li.map((li, i) => (
                      <li>
                        {li.bold && <b>{li.bold}</b>}
                        {li.li}
                      </li>
                    ))}
                </ul>
                <div className="spacer15" />
              </li>
            ))}
          </ul>
        </>
      )
    }
    return <></>
  }

  const GetAnchorTagAnswer = ({ ul, anchortag, href }) => {
    if (anchortag !== '') {
      const strArr = ul.split(anchortag)
      return (
        <>
          {strArr[0]}
          <a href={href}>{anchortag}</a>
          {strArr[1]}
        </>
      )
    }
    return <>{ul}</>
  }

  const GetAllQuestionsAnswersDivElem = () => {
    return Object.keys(faqListArr).map((arr, index) => {
      const topBottomBorder =
        index === Object.keys(faqListArr).length - 1
          ? 'topborder bottomborder'
          : 'topborder'
      return (
        <>
          <div
            className="col-sm-12"
            data-testid={`ques${arr}`}
            key={`ques_${arr}`}
          >
            <div className={topBottomBorder}>
              <div
                id={arr}
                className="collapsible"
                onClick={() => accordion(arr)}
              >
                <div className="row">
                  <div className={DeviceId.isMobile() ? 'col-9' : 'col-sm-11'}>
                    {faqListArr[arr].ques}
                  </div>
                  <div className={DeviceId.isMobile() ? 'col' : 'col-sm-1'}>
                    <div
                      className={`ansActionBtn ${DeviceId.isMobile() &&
                        'ansActionBtnMobile'}`}
                    >
                      <img
                        className={
                          DeviceId.isMobile() ? 'faqArrowMobile' : 'faqArrow'
                        }
                        src="https://img2.shaadi.com/assests/2020/images/loginArrow.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={`content`}>
                <div className="spacer15" />
                <GetAnswers {...faqListArr[arr]} />
                <GetListAnswers {...faqListArr[arr]} />
                {faqListArr[arr].showLink && (
                  <>
                    {' '}
                    <a href={`${baseUrl}/registration/user/login`}>
                      click here
                    </a>
                  </>
                )}
                {faqListArr[arr]['showCostWrapper'] && (
                  <>
                    <div className="spacer15" />
                    <div className="spacer15" />

                    {DeviceId.isMobile() ? (
                      <GetMembershipTypesMobile />
                    ) : (
                      <div className="row membershipCardStyle">
                        {' '}
                        <GetMembershipTypes />{' '}
                      </div>
                    )}
                  </>
                )}
                <div className="spacer15" />
                <div className="spacer15" />
              </div>
            </div>
          </div>
        </>
      )
    })
  }

  const accordion = clickedElem => {
    var acc = document.getElementsByClassName('collapsible')
    var current = document.getElementById(clickedElem)
    var content = current.nextElementSibling
    acc[clickedElem - 1].classList.toggle('active')
    for (var k = 0; k < acc.length; k++) {
      if (k !== clickedElem - 1) {
        var panel = document.getElementById(k + 1)
        var panelModal = panel.nextElementSibling
        panelModal.style.maxHeight = null
        acc[k].classList.remove('active')
        acc[k].firstChild.lastChild.firstChild.classList.remove(
          'ansActionBtnActive'
        )
        acc[k].firstChild.lastChild.firstChild.firstChild.style.transform =
          'rotate(1800deg)'
        acc[k].parentNode.classList.add('topborder')
        k === 9 && acc[k].parentNode.classList.add('bottomborder')
      }
    }

    if (content.style.maxHeight) {
      content.style.maxHeight = null
      acc[clickedElem - 1].firstChild.lastChild.firstChild.classList.remove(
        'ansActionBtnActive'
      )
      acc[
        clickedElem - 1
      ].firstChild.lastChild.firstChild.firstChild.style.transform =
        'rotate(1800deg)'
      current.parentNode.classList.add('topborder')
      clickedElem < acc.length &&
        acc[clickedElem].parentNode.classList.add('topborder')
      clickedElem === '10' &&
        acc[clickedElem - 1].parentNode.classList.add('bottomborder')
    } else {
      var contentHeight = content.scrollHeight + 60
      content.style.maxHeight = contentHeight + 'px'
      acc[clickedElem - 1].firstChild.lastChild.firstChild.classList.add(
        'ansActionBtnActive'
      )
      acc[
        clickedElem - 1
      ].firstChild.lastChild.firstChild.firstChild.style.transform =
        'rotate(0deg)'
      current.parentNode.classList.remove('topborder')
      clickedElem < acc.length &&
        acc[clickedElem].parentNode.classList.remove('topborder')
      clickedElem === '10' &&
        acc[clickedElem - 1].parentNode.classList.remove('bottomborder')
    }
  }
  return (
    <>
      {baseDomain === 'BengaliShaadi' && (
        <div className="brdr">
          <JsonLd />
          <div className="faqSectionWrapper" key="faqSection">
            <div className="container">
              <div className="row" key="innerfaqSection">
                <div
                  className="col-sm-12 txtcenter heading"
                  key="faqSectionHeader"
                >
                  Frequently Asked Questions
                </div>
                <GetAllQuestionsAnswersDivElem />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default FaqSection
